module.exports = __webpack_public_path__ + "img/powered-by.175d701d.png";